<template>
    <div class="tasks-dashboard-graph-container">
        <div ref="taskLocationGraph" style="width: 100%; height: 100%; overflow: hidden;"></div>
    </div>
</template>

<script>
const echarts = require('echarts');
import { EventBus } from '../../../../../../eventBus';
export default {
    name: "LocationInsightsDashboardGraph",
    props: {
        graphValues: {
            type: Array,
            required: true
        },
        graphColors: {
            type: Array,
            required: true
        },
        graphLabels: {
            type: Array,
            required: true
        },
        selectedGraphValueType: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            taskLocationGraphInstance: '',
            option: {
                color: ['#D26300', '#E29D5A', '#333333', '#F9CB9C'],

                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: (params) => {
                        let colorSpan = '<span style="display:inline-block;margin-right:5px;border-radius:2px;width:9px;height:9px;background-color:#d26300;"></span>';
                        if(params[0].name.includes('__')) {
                            let labelArr = params[0].name.split('__');
                            return `${params[0].seriesName}<br />
                            Location: ${this.titleCase(labelArr[1])}<br />
                            ${colorSpan} ${labelArr[0]}: ${params[0].data.value}%`;
                        } else {
                            return `${params[0].seriesName}<br />
                                ${colorSpan} ${params[0].name}: ${params[0].data.value}%`;
                        }
                    }
                },
                grid: {
                    right: '5%',
                    bottom: '20%'
                },
                legend: {
                    show: false,
                },
                dataZoom: [
                    {
                        show: false,
                        startValue: 0,
                        endValue: 18,
                        height: 20,
                        zoomLock: true,
                        zoomOnMouseWheel: false,
                        moveOnMouseMove: false,
                        moveOnMouseWheel: true,
                        preventDefaultMouseMove: true,
                        bottom: '0'
                    },
                    {
                        height: 20,
                        type: 'slider',
                        startValue: 0,
                        endValue: 100,
                        zoomLock: true,
                        labelFormatter: '',
                        moveOnMouseWheel: true,
                    },
                    {
                        show: false,
                        yAxisIndex: 0,
                        filterMode: 'empty',
                        width: 30,
                        height: '100%',
                        showDataShadow: false,
                        zoomLock: true,
                        left: '93%'
                    }
                ],
                xAxis: [
                    {
                        type: 'category',
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLabel: {
                            interval: 0,
                            rotate: 37, //If the label names are too long you can manage this by rotating the label.
                            overflow: 'truncate',
                            margin: 8,
                            hideOverlap: true,
                            align: 'right',
                            verticalAlign: 'top',
                            lineHeight: 6,
                            formatter: (value) => {
                                if(value.includes('__')) {
                                    let labelArr = value.split('__');
                                    return `${this.excerptText(this.titleCase(labelArr[0]), 9)}\n
                                    ${this.excerptText(this.titleCase(labelArr[1]), 9)}`;
                                } else {
                                    return this.excerptText(value, 9);
                                }
                            }
                        },
                        boundaryGap: true,
                        // prettier-ignore
                        data: ['East', 'West', 'North', 'South']
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '',
                        min: 0,
                        interval:25,
                        max: 100,
                        position: 'left',
                        alignTicks: true,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: '#333333'
                            }
                        },
                        axisLabel: {
                            formatter: '{value} %'
                        }
                    }
                ],
                series: [
                    {
                        name: 'Completion %',
                        type: 'bar',
                        yAxisIndex: 0,
                        barWidth: 50,
                        barCategoryGap: '10%',
                        data: [
                            {
                                value: 91,
                                itemStyle: {
                                    color: '#d26300'
                                }
                            },
                            {
                                value: 86,
                                itemStyle: {
                                    color: '#d67e31'
                                }
                            },
                            {
                                value: 61,
                                itemStyle: {
                                    color: '#cf8c53'
                                }
                            },
                            {
                                value: 39,
                                itemStyle: {
                                    color: '#d60918'
                                }
                            },
                        ],
                        label: {
                            show: true,
                            position: 'top',
                            color: '#FFFFFF',
                            backgroundColor: '#d26300',
                            padding: 4,
                            fontSize: 12,
                            formatter: '{c}%'
                        }
                    }
                ]
            }
        }
    },
    watch: {
        graphValues(newValue, oldValue) {
            this.reRenderGraph();
        }
    },
    mounted() {
        setTimeout(() => {
            this.reRenderGraph();
        }, 100);
    },
    beforeDestroy() {
        EventBus.$off();
    },
    methods:{
        initGraph() {
            this.option.series[0].name = this.selectedGraphValueType == 'completion_percentage' ? 'Completion %' : 'Score %';
            let chartContainer = this.$refs.taskLocationGraph;
            this.taskLocationGraphInstance = echarts.init(chartContainer);
            this.taskLocationGraphInstance.setOption(this.option);
            this.taskLocationGraphInstance.showLoading();
        },
        reRenderGraph() {
            this.initGraph();
            this.option.xAxis[0].data = this.graphLabels.map(el => this.titleCase(el));
            this.option.series[0].data = this.graphValues.map((el, index) => ({
                value: el,
                itemStyle: {
                    color: this.graphColors[index]
                }
            }));
            this.option.color = this.graphColors;
            this.taskLocationGraphInstance.clear();
            this.taskLocationGraphInstance.setOption(this.option);
            this.taskLocationGraphInstance.hideLoading();
        },
        titleCase(str) {
			let splitStr = str ? str.toLowerCase().split(" ") : str;
			for (let i = 0; i < splitStr.length; i++) {
				splitStr[i] =
					splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
			}
			return splitStr.join(" ");
		},
        excerptText(text, length = 10, clamp = "...") {
			return text.length > length
				? text.toString().slice(0, length) + clamp
				: text;
		},
    }

}
</script>

<style>
.tasks-dashboard-graph-container{
    background-color: #ffffff;
    padding: 25px;
    height: 500px;
    width:100%;
    margin: 20px 0;

}


</style>